export default class ActionCardReplacementsProcessor {
  constructor(actionCardModel) {
    this.actionCardModel = actionCardModel
  }

  process(template) {
    if (!this.actionCardModel?.replacementProcessor) {
      return template
    }
    return this.actionCardModel.replacementProcessor.processReplacements(template)
  }
}
